module.exports = __webpack_public_path__ + "static/media/carliepetraitis.7639f09c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/finals/portfolios/carliepetraitis.png
// module id = 295
// module chunks = 0